<template>
<div>
    <div class="ui-content dashboard">
            <div class="data-table-section health-report chapter-hltmain">
                    <div class="back-btn-and-chapter">
                            <v-btn
                                    @click="onBack()"
                                    class="right-btn cust-btn mobile-show-btn"
                                    color="primary"
                                    >Back
                                </v-btn>
                        </div>
                <v-row>
                    <v-col col="3" sm="3" class="border-right-health">
                        <div class="subject-name-prog">{{selectedSubject.name}}</div>
                        <div class="fix-left-progress feb-18-chapter-health">
                            <div class="chapter-halth-progress">
                                <div class="vertical-progress">
                                    <div
                                        :class="selectedSubject.health >= 85 ? 'plus-80-percenage-count' : 'less-percentage'"
                                        v-if="selectedSubject.health <= 10"
                                    >
                                        <div class="percenage-count">{{selectedSubject.health + '%'}}</div>
                                    </div>
                                    <div
                                        class="progress-percentage"
                                        :style="{background: getColor(selectedSubject.health),height: selectedSubject.health+'%'}"
                                    >
                                        <div
                                            class="calc-percentage"
                                            v-if="selectedSubject.health > 10"
                                        >{{selectedSubject.health + '%'}}</div>
                                    </div>
                                </div>
                                <div class="sub-health">Subject Health</div>
                            </div>
                        </div>
                    </v-col>
                    <v-col col="9" sm="9" class="chapter-hlt">
                        <div class="back-btn-and-chapter">
                            <div class="subject-name-prog">Chapterwise Health</div>
                            <v-btn
                                    @click="onBack()"
                                    class="right-btn cust-btn show-desktop-btn"
                                    color="primary"
                                    >Back
                                </v-btn>
                        </div>
                        <div class="Chapterwise-scroll-outer">
                            <div class="Chapterwise-scroll">
                                
                                <div
                                    class="proress-block-health"
                                    v-for="(chapter) in selectedSubject.chapters"
                                    :key="chapter.id"
                                >
                                    <div class="prog-plus-block">
                                        <div class="subject-details">
                                            <div class="subject-progress">
                                                <v-progress-linear
                                                    :color="getColor(chapter.health)"
                                                    :height="35"
                                                    :value="chapter.health"
                                                >
                                                    <div class="progressbar-content">
                                                        <div class="chapter-health-content">
                                                            <div class="float-left">{{chapter.name}}</div>
                                                            <div class="float-right">{{chapter.health}}%</div>
                                                        </div>
                                                    </div>
                                                </v-progress-linear>
                                            </div>
                                            <div class="add-subject">
                                                <v-btn
                                                    @click="openTopicHealthDetails(chapter)"
                                                    class="add-btn"
                                                    fab
                                                >
                                                    <v-icon dark>mdi-plus</v-icon>
                                                </v-btn>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
    </div>
</div>
</template>
<script>
import ProgressBar from "@/components/common/ProgressBar.vue";
import { mapActions, mapState } from "vuex";

export default {
    components: {
        ProgressBar
    },
    props: ["selectedSubject", "studentId"],
    data() {
        return {};
    },
    methods: {
        ...mapActions({
            setSelectedChapter: "healthStore/setSelectedChapter"
        }),
        openTopicHealthDetails(chapter) {
            this.$root.showLoader = true;
            this.setSelectedChapter(chapter);
            let subject = this.selectedSubject.name;
            let subject_id = this.selectedSubject.id;
            let chapter_id = chapter.id;
            this.$router.push({
                name: "topic-health",
                params: { subject, subject_id, chapter_id, student_id: this.studentId }
            });
        },
        getColor(percentage) {
            let color = "";

            if (percentage > 65) {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.GREEN;
            } else if (percentage > 19) {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.ORANGE;
            } else {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.RED;
            }
            return color;
        },
        onBack() {
            this.$router.push({ name: "my-health"});
        },
    },
    computed: {
        ...mapState("userStore", ["user"])
    },
};
</script>